import { useMemo } from "react";
import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";
import { useFavorites } from "@/hooks/useFavorites";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function Favorites() {
  const { favorites } = useFavorites();

  useDocumentMeta(
    "我的收藏 - 国产在线观看",
    "查看你在国产在线观看收藏的国产电影、电视剧与综艺节目，收藏内容保存在本地浏览器中。"
  );

  const list = useMemo(
    () => movies.filter((m) => favorites.includes(m.id)),
    [favorites]
  );

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 py-6 md:px-6 md:py-8">
      <nav aria-label="面包屑" className="flex items-center gap-1.5 text-xs text-foreground-500">
        <Link to="/" className="transition-colors hover:text-primary-600">
          首页
        </Link>
        <i className="ri-arrow-right-s-line" aria-hidden="true" />
        <span className="text-foreground-800">我的收藏</span>
      </nav>

      <header className="mt-4">
        <h1 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          <i className="ri-heart-3-fill text-accent-500" aria-hidden="true" />
          我的收藏
        </h1>
        <p className="mt-2 text-sm text-foreground-600">
          收藏保存在本地浏览器中，共 <span className="font-bold text-primary-600">{list.length}</span> 部作品。
        </p>
      </header>

      {list.length === 0 ? (
        <div className="mt-6 rounded-lg border border-dashed border-background-300 bg-background-50 py-16 text-center">
          <i className="ri-heart-3-line text-4xl text-foreground-400" aria-hidden="true" />
          <p className="mt-3 text-base font-medium text-foreground-800">还没有收藏任何作品</p>
          <p className="mt-1 text-sm text-foreground-500">
            在影视详情页点击"收藏"，就能在这里随时找到它们
          </p>
          <Link
            to="/"
            className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-compass-3-line text-base" aria-hidden="true" />
            去发现好剧
          </Link>
        </div>
      ) : (
        <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {list.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      )}
    </div>
  );
}